/**
 * PipelineGateBanner · shown at the top of a locked status page.
 * Explains why data-entry is disabled and points to what must complete first.
 */
import React from 'react';
import { Lock } from 'lucide-react';
import { STATUS_ORDER, STATUS_LABELS } from '../pipelineApi';

export default function PipelineGateBanner({ ladder, statusKey }) {
  // Find the first earlier status that isn't complete — that's the blocker
  const idx = STATUS_ORDER.indexOf(statusKey);
  let blocker = null;
  for (let i = 0; i < idx; i++) {
    const row = ladder.find(r => r.status_key === STATUS_ORDER[i]);
    if (!row || row.state !== 'complete') { blocker = STATUS_ORDER[i]; break; }
  }
  return (
    <div className="bg-amber-50 border-l-4 border-amber-400 px-4 py-3 flex items-center gap-3"
         data-testid="wf-gate-banner">
      <Lock size={18} className="text-amber-600 flex-shrink-0" />
      <div className="flex-1">
        <div className="text-sm font-semibold text-amber-900">
          {STATUS_LABELS[statusKey]} is locked for this appraisal
        </div>
        <div className="text-xs text-amber-800 mt-0.5">
          {blocker ? (
            <>Complete <span className="font-semibold">{STATUS_LABELS[blocker]}</span> before entering data here.</>
          ) : (
            <>Complete every earlier status before entering data here.</>
          )}{' '}You can preview the task list below in read-only mode.
        </div>
      </div>
    </div>
  );
}
